import type { SketchViewer } from '@api/appBuilder';
import type { Box } from './sketchLayout';

export const ART_W = 408;
export const ART_H = 292;

const circle = (cx: number, cy: number, r: number) =>
  `M${cx + r} ${cy} a${r} ${r} 0 1 1 ${-2 * r} 0 a${r} ${r} 0 1 1 ${2 * r} 0`;

export const VIEWER_ART: Readonly<Record<SketchViewer, readonly string[]>> = {
  model: [
    'M204 56 L282 101 L282 191 L204 236 L126 191 L126 101 Z',
    'M126 101 L204 146 L282 101 M204 146 L204 236',
    'M90 262 H318',
  ],
  room: ['M84 60 H324 V200 H84 Z', 'M84 200 L40 262 M324 200 L368 262 M40 262 H368', 'M150 92 h60 v52 h-60 Z', 'M232 170 h70 v30 h-70 Z'],
  simulation: [
    'M40 110 C140 110 140 70 240 70 S 368 110 368 110',
    'M40 190 C140 190 140 150 240 150 S 368 190 368 190',
    'M60 150 C150 150 150 112 240 112 S 350 150 350 150',
    'M60 132 C150 132 150 94 240 94 S 350 132 350 132',
  ],
  image: ['M74 56 H334 V236 H74 Z', 'M74 210 L150 140 L210 190 L260 150 L334 210', circle(280, 100, 18)],
  chart: ['M70 240 V60 M70 240 H350', 'M90 210 L150 160 L210 180 L270 110 L330 90', 'M110 240 v-30 M170 240 v-60 M230 240 v-45 M290 240 v-90'],
  document: [
    'M124 40 H264 L294 70 V252 H124 Z',
    'M264 40 V70 H294',
    'M150 100 H268 M150 130 H268 M150 160 H240 M150 190 H268 M150 220 H220',
  ],
  drawing: ['M60 50 H348 V242 H60 Z', 'M260 206 H348 M260 206 V242', 'M100 90 h80 v70 h-80 Z', circle(270, 125, 30), 'M100 178 H180 M100 172 v12 M180 172 v12'],
  generic: ['M74 56 H334 V236 H74 Z', 'M74 56 L334 236 M334 56 L74 236'],
};

export const artPlacement = (box: Box): { transform: string; scale: number } => {
  const scale = Math.max(0.05, Math.min(1, (box.w - 24) / ART_W, (box.h - 24) / ART_H));
  const x = box.x + (box.w - ART_W * scale) / 2;
  const y = box.y + (box.h - ART_H * scale) / 2;
  return { transform: `translate(${x} ${y}) scale(${scale})`, scale };
};
